var scope_0 = require('/home/runner/work/react-use-window-sessionstorage/react-use-window-sessionstorage/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/143ba5cbe9ff421a49dc77e41ca95471.js').default;

var scope_1 = require('/home/runner/work/react-use-window-sessionstorage/react-use-window-sessionstorage/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5ed23b87e2c4183fe1e2d95ccb0a14b5.js').default;

var scope_2 = require('/home/runner/work/react-use-window-sessionstorage/react-use-window-sessionstorage/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a09adece1895f9d565141dbf97f8741d.js').default;

var scope_3 = require('/home/runner/work/react-use-window-sessionstorage/react-use-window-sessionstorage/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a8c6c5c3846507b667d35f5d50287055.js').default;

var scope_4 = require('/home/runner/work/react-use-window-sessionstorage/react-use-window-sessionstorage/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c05502ef9ea8de3edfba59df3a6108d2.js').default;

var scope_5 = require('/home/runner/work/react-use-window-sessionstorage/react-use-window-sessionstorage/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c1bb10eefc4de7803cc6391670eaead5.js').default;

var scope_6 = require('/home/runner/work/react-use-window-sessionstorage/react-use-window-sessionstorage/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d0bb33b4826c5cef106d380be1d8ba57.js').default;

var scope_7 = require('/home/runner/work/react-use-window-sessionstorage/react-use-window-sessionstorage/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

var __DOCZ_DUMMY_EXPORT_DEFAULT = Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}